var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFt02(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 63,
    height: 63,
    viewBox: "0 0 63 63",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.5 0C14.1308 0 0 14.1308 0 31.5C0 48.8692 14.1308 63 31.5 63C48.8692 63 63 48.8692 63 31.5C63 14.1308 48.8692 0 31.5 0ZM31.5 60.0469C15.7592 60.0469 2.95312 47.2408 2.95312 31.5C2.95312 15.7592 15.7592 2.95312 31.5 2.95312C47.2408 2.95312 60.0469 15.7592 60.0469 31.5C60.0469 47.2408 47.2408 60.0469 31.5 60.0469ZM47.5774 24.5725H38.4275V15.4226C38.4275 15.031 38.272 14.6554 37.9951 14.3785C37.7182 14.1016 37.3426 13.946 36.951 13.946H26.049C25.6574 13.946 25.2818 14.1016 25.0049 14.3785C24.728 14.6554 24.5725 15.031 24.5725 15.4226V24.5725H15.4226C15.031 24.5725 14.6554 24.728 14.3785 25.0049C14.1016 25.2818 13.946 25.6574 13.946 26.049V36.9521C13.946 37.3437 14.1016 37.7193 14.3785 37.9962C14.6554 38.2731 15.031 38.4286 15.4226 38.4286H24.5725V47.5779C24.5725 47.9695 24.728 48.3451 25.0049 48.622C25.2818 48.8989 25.6574 49.0545 26.049 49.0545H36.951C37.3426 49.0545 37.7182 48.8989 37.9951 48.622C38.272 48.3451 38.4275 47.9695 38.4275 47.5779V38.4282H47.5769C47.9685 38.4282 48.3441 38.2726 48.621 37.9957C48.8979 37.7188 49.0535 37.3432 49.0535 36.9516V26.049C49.0535 25.6575 48.898 25.282 48.6212 25.0051C48.3444 24.7282 47.969 24.5726 47.5774 24.5725ZM46.1009 35.4755H36.951C36.5594 35.4755 36.1838 35.6311 35.9069 35.908C35.63 36.1849 35.4744 36.5605 35.4744 36.9521V46.1014H27.5256V36.9516C27.5256 36.56 27.37 36.1844 27.0931 35.9075C26.8162 35.6306 26.4406 35.475 26.049 35.475H16.8991V27.5256H26.049C26.4406 27.5256 26.8162 27.37 27.0931 27.0931C27.37 26.8162 27.5256 26.4406 27.5256 26.049V16.8991H35.4744V26.049C35.4744 26.4406 35.63 26.8162 35.9069 27.0931C36.1838 27.37 36.5594 27.5256 36.951 27.5256H46.1004L46.1009 35.4755Z",
    fill: "url(#paint0_linear_1682_542)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1682_542",
    x1: 31.5,
    y1: -2.29477e-8,
    x2: 31.498,
    y2: 65.0323,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BDA6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#070430"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFt02);
export default __webpack_public_path__ + "static/media/ft_02.3bacec07fb209355f4c8e14413bdba08.svg";
export { ForwardRef as ReactComponent };